export default __webpack_public_path__ + "static/media/telematico.d6b5d958.jpg";